import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const SplitHorizontalIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 4.5H5.5C4.39543 4.5 3.5 5.39543 3.5 6.5V12V17.5C3.5 18.6046 4.39543 19.5 5.5 19.5H12M12 4.5H18.5C19.6046 4.5 20.5 5.39543 20.5 6.5V12V17.5C20.5 18.6046 19.6046 19.5 18.5 19.5H12M12 4.5V9.5M12 19.5V14.5"
            stroke="currentColor" strokeWidth="0.85" strokeLinecap="round"/>
        <path d="M7 12H17M7 12L8.5 10.5M7 12L8.5 13.5M17 12L15.5 10.5M17 12L15.5 13.5" stroke="currentColor" strokeWidth="0.85" strokeLinecap="round"/>
    </svg>
)

const SplitHorizontalIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {SplitHorizontalIconSvg}
    </SvgIcon>
);

export default SplitHorizontalIcon